<script setup lang="ts">
import type { ReportInfoProps } from '@/types/appTypes'

const props = withDefaults(defineProps<ReportInfoProps>(), { smallerRow: false })

const app = useNuxtApp()

let eventItem = null as Article | null // 関連記事：イベント
let sPeriodLabel = null // 会期
let sPeriodRemain = null // 開催中情報
let sClosedPeriod = null // 休館日
let sAddress = null // 住所
let sTell = null // TEL
let sOfficialUrl = null // 公式URL
let sVenue = null // 会場
let sMuseumArticleSlug = null // ミュージアムスラッグ
let sOpenTime = null // 開館時間
const parsedTel = {
  number: '',
  href: '',
  label: '',
}

// 関連記事からイベント取得
eventItem = app.$getArticleRelationsSingle(props.item, 'event', null)
if (eventItem) {
  // 開館時間
  if (!sOpenTime) {
    if (eventItem.custom) {
      if (eventItem.custom.event_opening_hour) {
        sOpenTime = eventItem.custom.event_opening_hour
      } else if (eventItem.custom.custom_museum_opening_hour) {
        sOpenTime = eventItem.custom.custom_museum_opening_hour
      }
    }
  }
}

// 会場
if (!sVenue) {
  if (props.item && props.item.custom && props.item.custom.kaijo) {
    // レポートから
    sVenue = props.item.custom.kaijo
  } else if (eventItem) {
    // イベントから
    sVenue = app.$getEventVenue(eventItem, false)
    if (app.$isEventVenueMuseum(eventItem)) {
      if (!sMuseumArticleSlug) {
        sMuseumArticleSlug = app.$getEventMuseumArticleSlug(eventItem)
      } // ミュージアムスラッグ
    }
  }
}

// 会期
if (!sPeriodLabel) {
  if (props.item && props.item.custom && props.item.custom.kikan) {
    // アイテムから
    sPeriodLabel = props.item.custom.kikan // 会期
    // sPeriodRemain = null // 開催中情報
    if (eventItem && eventItem.day_count_display === 1) {
      sPeriodRemain = app.$getEventPeriodRemain(eventItem) // 開催中情報
    }
  } else if (eventItem) {
    // イベントから
    sPeriodLabel = app.$getEventPeriodLabel(eventItem) // 会期
    if (eventItem.day_count_display === 1) {
      sPeriodRemain = app.$getEventPeriodRemain(eventItem) // 開催中情報
    }
  }
}

// 休館日
if (!sClosedPeriod) {
  if (eventItem && eventItem.custom) {
    if (eventItem.custom.museum_close_day) {
      sClosedPeriod = eventItem.custom.museum_close_day
    } else if (eventItem.custom.custom_museum_closed_period) {
      sClosedPeriod = eventItem.custom.custom_museum_closed_period
    }
  }
}

// 住所取得
if (!sAddress) {
  if (props.item && props.item.custom && props.item.custom.address) {
    sAddress = props.item.custom.address
  } else if (eventItem) {
    sAddress = app.$getEventAddress(eventItem, true)
  }
}

// TEL取得
if (!sTell) {
  if (props.item && props.item.custom && props.item.custom.tel) {
    sTell = props.item.custom.tel
  } else if (eventItem) {
    sTell = app.$getEventTell(eventItem)
  }
}

// 公式URL取得
if (!sOfficialUrl) {
  if (props.item && props.item.custom && props.item.custom.hp) {
    sOfficialUrl = props.item.custom.hp
  } else if (eventItem && eventItem.custom && eventItem.custom.event_url) {
    sOfficialUrl = eventItem.custom.event_url
  }
}

const setParsedTel = () => {
  const raw = sTell || ''
  const match = raw.match(/[\d-]+/)

  parsedTel.number = match ? match[0] : ''
  parsedTel.href = match ? match[0].replace(/-/g, '') : ''
  parsedTel.label = match ? raw.replace(match[0], '') : ''
}
setParsedTel()
</script>

<template>
  <div class="l-container">
    <table>
      <tbody>
        <tr v-if="sVenue">
          <td
            v-bind:class="{ smaller: smallerRow }"
          >
            会場
          </td>
          <td
            v-bind:class="{ smaller: smallerRow }"
          >
            <nuxt-link
              v-if="sMuseumArticleSlug"
              v-bind:to="{ path: `/museum/${sMuseumArticleSlug}` }"
            >
              <div
                v-html="sVenue"
              />
            </nuxt-link>
            <div
              v-else
              v-html="sVenue"
            />
          </td>
        </tr>

        <tr v-if="sPeriodLabel || sPeriodRemain">
          <td
            v-bind:class="{ smaller: smallerRow }"
          >
            会期
          </td>
          <td
            v-bind:class="{ smaller: smallerRow }"
          >
            <div>
              {{ sPeriodLabel }}
            </div>
            <div
              v-if="sPeriodRemain"
              v-bind:style="{ color: sPeriodRemain.color }"
            >
              {{ sPeriodRemain.label }}
            </div>
          </td>
        </tr>
        <tr v-if="sOpenTime">
          <td
            v-bind:class="{ smaller: smallerRow }"
          >
            開館時間
          </td>
          <td
            v-bind:class="{ smaller: smallerRow }"
          >
            <div
              v-html="app.$trimEnter(sOpenTime)"
            />
          </td>
        </tr>
        <tr v-if="sClosedPeriod">
          <td
            v-bind:class="{ smaller: smallerRow }"
          >
            休館日
          </td>
          <td
            v-bind:class="{ smaller: smallerRow }"
          >
            <div
              v-html="app.$trimEnter(sClosedPeriod)"
            />
          </td>
        </tr>
        <tr v-if="sAddress">
          <td
            v-bind:class="{ smaller: smallerRow }"
          >
            住所
          </td>
          <td
            v-bind:class="{ smaller: smallerRow }"
          >
            <div
              v-html="app.$trimEnter(sAddress)"
            />
          </td>
        </tr>
        <tr v-if="sTell">
          <td
            v-bind:class="{ smaller: smallerRow }"
          >
            電話
          </td>
          <td
            v-bind:class="{ smaller: smallerRow }"
          >
            <span class="pc-only">{{ sTell }}</span>
            <div
              v-if="parsedTel.number"
              class="sp-only"
            >
              <a
                v-bind:href="'tel:' + parsedTel.href"
              >
                {{ parsedTel.number }}
              </a>{{ parsedTel.label }}
            </div>
          </td>
        </tr>
        <tr v-if="sOfficialUrl">
          <td
            v-bind:class="{ smaller: smallerRow }"
          >
            公式サイト
          </td>
          <td
            v-bind:class="{ smaller: smallerRow }"
          >
            <a
              v-bind:href="sOfficialUrl"
              target="_blank"
            >
              {{ sOfficialUrl }}
            </a>
          </td>
        </tr>
        <tr v-if="eventItem && eventItem.custom && eventItem.custom.event_admission_fee">
          <td
            v-bind:class="{ smaller: smallerRow }"
          >
            料金
          </td>
          <td
            v-bind:class="{ smaller: smallerRow }"
          >
            <div
              v-html="app.$trimEnter(eventItem.custom.event_admission_fee)"
            />
          </td>
        </tr>
        <tr v-if="eventItem && eventItem.article_type_slug && eventItem.title">
          <td
            v-bind:class="{ smaller: smallerRow }"
          >
            展覧会詳細
          </td>
          <td
            v-bind:class="{ smaller: smallerRow }"
          >
            <nuxt-link
              v-bind:to="{ path: `/event/${eventItem.article_slug}` }"
            >
              {{ eventItem.title }}　詳細情報
            </nuxt-link>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive";

.l-container {
  width: 100%;

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: var(--g_font_family_NotoSansCJKjp);
    font-size: 14px;

    @include responsive.mq_down(sp) {
      display: block;
    }

    tr,
    th,
    td {
      transform: rotate(0.03deg);

      @include responsive.mq_down(sp) {
        display: block;
      }
    }

    tr {
      td {
        padding: 9px 20px;
        border: 1px solid #ebebeb;

        @include responsive.mq_down(sp) {
          padding: 6px 10px;
          word-break: break-all;
        }

        &:first-child {
          width: 150px;
          border: 1px solid #ebebeb;
          background: #ebebeb;
          color: #252525;
          font-weight: bold;

          @include responsive.mq_down(sp) {
            width: 100%;
          }
        }

        &:last-child {
          width: calc(100% - 150px);
          line-height: 1.85;

          @include responsive.mq_down(sp) {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
